import { createContext, useContext } from "react";

interface IMegaOptionContextProps extends React.PropsWithChildren<unknown> {
    checked?: string;
    name: string | undefined;
    onChange: (value: string) => void;
}

const MegaOptionContext = createContext<IMegaOptionContextProps>({
    checked: "",
    name: undefined,
    onChange: () => {},
});

export default function MegaOptionGroup(props: IMegaOptionContextProps) {
    return (
        <>
            <MegaOptionContext.Provider value={props}>
                {props.children}
            </MegaOptionContext.Provider>
        </>
    );
}

export function useMegaOptionGroup() {
    const context = useContext(MegaOptionContext);
    if (!context)
        throw new Error(
            "useMegaOptionGroup necessita de um MegaOptionContextProvider em volta do que sera utilizado"
        );

    return context;
}
